import { UserIcon } from '@heroicons/react/24/outline';
import Button from 'common/components/Button/Button';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon/Icon';
import Role from 'common/components/Role/Role';
import Status from 'common/components/Status/Status';
import WarningIcon from 'components/Icon/icons/WarningIcon';
import { Establishment } from 'types/Establishment';
import useAuth from 'common/hooks/useAuth';

function MediatorItem({ item: user, onDelete, onNavigate }: any) {
  const { user: currentUser } = useAuth();
  const operator = user.operator;
  const {
    username = user.email,
    lastname = null,
    firstname = null,
    establishments = [],
  } = operator || {};

  const detailsLink =
    user.id === currentUser?.id
      ? `/availability`
      : !!operator
      ? `/mediators/${user.id}`
      : `/users/edit/${user.id}`;

  const { t } = useTranslation();

  return (
    <div className="white-box responsive-flex-lg px-4 py-4 mt-2 w-full relative cursor-pointer transition-all">
      <Link to={detailsLink} className="responsive-flex-lg flex-1">
        <div className="flex flex-col flex-1 justify-between lg:pl-4 lg:pr-4">
          <div className="flex h-full gap-3">
            <div className="grid w-full gap-1 pt-3 lg:py-0">
              <div className="flex flex-row w-full items-center gap-1 mb-1 text-xl flex-wrap">
                <span className="font-bold text-primary leading-4">{username}</span>
                {' -  '}
                <span className="leading-4">{firstname}</span>
                <span className="leading-4">{lastname}</span>
                <div className="flex flex-row flex-1 justify-end items-center gap-1 text-lg">
                  <UserIcon className="w-4 h-4 mr-1" />
                  {user?.email}
                </div>
              </div>

              {!!operator ? (
                <div className="flex flex-col gap-1">
                  {establishments && establishments.length > 0
                    ? establishments.map((establishment: Establishment) => {
                        return (
                          <div
                            key={establishment.id}
                            className="flex flex-row items-center gap-2 text-sm"
                          >
                            <Icon name="EstablishmentIcon" className="w-4 h-4 mt-1" />
                            {`${establishment?.name} (${String(
                              establishment?.department?.CP
                            ).padStart(2, '0')})`}
                          </div>
                        );
                      })
                    : '-'}
                </div>
              ) : (
                <div className="flex flex-row items-center gap-1 text-amber-700 italic opacity-60">
                  <WarningIcon className="w-4 h-4 mr-1" />
                  <div>{t('titleLegends.noProfile')}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Link>

      <div className="flex flex-col justify-between items-end text-xs lg:border-l pl-4 min-w-[24em] border-slate-150 gap-2">
        <div className={user?.role ? 'flex justify-end gap-2' : ''}>
          <Role userRole={user?.role?.name} />
          <Status status={user?.blocked ? 'blocked' : 'active'} />
        </div>

        <div className="flex w-full items-center justify-end text-slate-500">
          <div>
            <div className="flex w-full gap-1">
              <Button
                type="error-line"
                icon="TrashIcon"
                compact
                onClick={() => onDelete(user.id)}
                confirmMessage={t('actions.confirmDelete')}
              />
              <Button
                title={t('actions.edit')}
                type="warning-line"
                icon="PencilSquareIcon"
                onClick={() => onNavigate(user.id)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MediatorItem;
